module.exports = __webpack_public_path__ + "img/banner-brf.187614c1.jpg";